interface Zone {
  id: number
  [key: string]: unknown
}

interface StoredZone {
  email?: string
  zoneId?: string
}

interface ResolveZoneInput {
  availableZones: Zone[]
  currentUser: { email?: string }
  storedZone: StoredZone
}

const findZoneById = (availableZones: Zone[], rawId: string | undefined | null): Zone | undefined => {
  if (!rawId) return undefined
  const id = Number(rawId)
  if (!Number.isFinite(id)) return undefined
  return availableZones.find(zone => zone.id === id)
}

export const resolveZoneToRestore = ({
  availableZones,
  currentUser,
  storedZone,
}: ResolveZoneInput): Zone | undefined => {
  if (!currentUser?.email || !availableZones.length) return undefined

  const fromStorage =
    storedZone.email === currentUser.email ? findZoneById(availableZones, storedZone.zoneId) : undefined

  return fromStorage ?? availableZones[0]
}
